import React, { Component } from "react";
import { Footer } from "../global/footer";

export default class LayoutContactUs extends Component {
  render() {
    return (
      <div className="layout--contact-us">
        {this.props.children}
        <Footer />
      </div>
    );
  }
}
